import { Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';

interface PricingTraditionalProps {
  price?: number | null;
  /** True for pre-listing homes, whose price is set but not yet public. */
  isAvailableSoon?: boolean;
}

function traditionalPriceLabel(price?: number | null, isAvailableSoon?: boolean) {
  if (price) {
    return formatCurrency(price);
  }
  return isAvailableSoon ? 'Price pending' : 'Price not available';
}

export const PricingTraditional = ({ price, isAvailableSoon }: PricingTraditionalProps) => {
  return (
    <Row className="items-center">
      <Text as="h2" className="pb-6 text-header-md text-od-content-primary">
        {traditionalPriceLabel(price, isAvailableSoon)}
      </Text>
    </Row>
  );
};
